import { useMutation, useQuery } from "react-query";
import { ERoleType } from "../enum";
import * as usersService from '../services/userService';
import { ListDto } from "../types/dto";
import { ListUsersDto } from "../types/dto/ListUsersDto";

const getUsers = async (dto: ListUsersDto) => {
  if (dto.role === 'all') dto.role = '';
  if (dto.status === 'all') dto.status = '';
  return await usersService.getUsers(dto);
}

const getFlaggedUsers = async (dto: ListDto) => {
  return await usersService.getFlaggedUsers(dto);
}

const updateUserRole = async ({ userId, role }: {
  userId: string,
  role: ERoleType,
}) => {
  return usersService.updateUserRole(userId, role);
}

const updateCanSuggestProducts = async ({ userId, canSuggestProducts }: {
  userId: string,
  canSuggestProducts: boolean,
}) => {
  return usersService.updateCanSuggestProducts(userId, canSuggestProducts);
}

const blockUser = async ({ endUserId, deviceIds }: { endUserId: string, deviceIds: string[] }) => {
  return usersService.blockUser(endUserId, deviceIds);
}

const unblockUser = async (endUserId: string) => {
  return usersService.unblockUser(endUserId);
}


// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

export const useGetUsers = (dto: ListUsersDto, options = {}) => {
  return useQuery({
    queryKey: ['users', dto],
    queryFn: () => getUsers(dto),
    ...options
  });
}

export const useGetFlaggedUsers = (dto: ListDto, options = {}) => {
  return useQuery({
    queryKey: ['flagged-users', dto],
    queryFn: () => getFlaggedUsers(dto),
    ...options
  });
}

export const useUpdateUserRole = (onSuccess: any, onError: any) => {
  return useMutation(updateUserRole, {
    onSuccess,
    onError
  });
}

export const useUpdateCanSuggestProducts = (onSuccess: any, onError: any) => {
  return useMutation(updateCanSuggestProducts, {
    onSuccess,
    onError
  });
}

export const useBlockUser = (onSuccess: any, onError: any) => {
  return useMutation(blockUser, {
    onSuccess,
    onError
  });
}

export const useUnblockUser = (onSuccess: any, onError: any) => {
  return useMutation(unblockUser, {
    onSuccess,
    onError
  });
}